import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from 'RiskProfilesApp/features/risk-profiles-shared/state/risk-profiles-new-edit.store';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { CheckboxGroupModule } from 'NewAngular/features/components/inputs/checkbox-group/checkbox-group.module';
import { EditInPlaceModule } from 'NewAngular/features/components/inputs/edit-in-place/edit-in-place.module';
import { EditInWYSIWYGModalModule } from 'NewAngular/features/components/inputs/edit-in-wysiwyg-modal/edit-in-wysiwyg-modal.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { PromptModalModule } from 'NewAngular/features/components/modals/prompt-modal/prompt-modal.module';
import { SharingModalModule } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.module';
import { TemplateModalModule } from 'NewAngular/features/components/modals/template-modal/template-modal.module';
import { TextEditModule } from 'NewAngular/features/components/modals/text-edit/text-edit.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { PageErrorMessageModule } from 'NewAngular/features/components/page-error-message/page-error-message.module';
import { ListPagePaginationModule } from 'NewAngular/features/components/pagination/list-page-pagination/list-page-pagination.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { IndexOfPipeModule } from 'NewAngular/features/pipes/index-of/index-of-pipe.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { getLogger } from 'NewAngular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
export class RiskProfilesSharedModule {
}
RiskProfilesSharedModule.ɵfac = function RiskProfilesSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfilesSharedModule)(); };
RiskProfilesSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RiskProfilesSharedModule, bootstrap: [TopBarNavComponent] });
RiskProfilesSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        BrowserModule,
        CheckboxGroupModule,
        ConfigModule,
        ConfirmModalModule,
        DisabledModule,
        FormsModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        HelpModalModule,
        IconModule,
        IndexOfPipeModule,
        IsSharedWithOthersPipeModule,
        ListPagePaginationModule,
        LoadingSymbolModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        NavigationModule,
        PageErrorMessageModule,
        PromptModalModule,
        SideMenuModule,
        RouterModule.forRoot([], { useHash: true }),
        SharingModalModule,
        SimpleDropdownModule,
        StoreModule.forRoot({ rootReducer }, { metaReducers: getLogger() }),
        TemplateModalModule,
        TextEditModule,
        TooltipModule,
        EditInPlaceModule,
        EditInWYSIWYGModalModule,
        FoldersSharedModule] });
